import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { crudActions } from '@sm/services/crudActions';
import { showToast } from '@sm/store/toastSlice';

export const useUnreadNotifications = (isLoggedIn) => {
  const dispatch = useDispatch();
  const [count, setCount] = useState(0);
  const location = useLocation();

  const fetchUnread = useCallback(async () => {
    if (!isLoggedIn) return;

    try {
      const response = await crudActions.get('v1/notifications/has-unread', {}, true);
      setCount(response);
    } catch (error) {
      dispatch(showToast('danger', 'Failed to fetch unread notifications.'));
    }
  }, [isLoggedIn, dispatch]);

  useEffect(() => {
    if (isLoggedIn) {
      fetchUnread();
    }
  }, [location.pathname, isLoggedIn, fetchUnread]);

  useEffect(() => {
    if (!isLoggedIn) return;

    const handleFocus = () => fetchUnread();

    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, [isLoggedIn, fetchUnread]);

  useEffect(() => {
    if (!isLoggedIn) {
      setCount(0);
    }
  }, [isLoggedIn]);

  return count;
};
